<template>
  <div>
    <div class="flex flex-column align-center justify-center">
      <div>
        <img class="w-500" src="@/assets/img/403.svg">
      </div>
      <div class="content">
        <h1>403</h1>
        <div class="desc">抱歉，你无权访问该页面</div>
        <div class="action">
          <el-button type="primary" @click="backHome">返回首页</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "E403",
  methods: {
    backHome() {
      this.$router.push("/index")
    }
  }
}
</script>

<style scoped>
.content h1{
  color: #434e59;
  font-size: 72px;
  font-weight: 600;
  line-height: 72px;
  margin-bottom: 24px;
}
.content .desc{
  color: #91ACFF;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 16px;
}

</style>
